import React, { useRef, useEffect } from "react"
import { Section, FixedWidthContent } from "@alexanderathoodly/ui-library"
import { BlockFooter } from "../blockfooter"
import { CommonBlockProps } from "../types"
import { getIconPath } from "../../helpers/getIconPath"

interface CustomWindow extends Window {
    typeformEmbed: {
        makeWidget: (e: HTMLDivElement | null, t: string) => void
    }
}

export interface TypeformProps extends CommonBlockProps {
    template: "typeform"
    typeform: string
}

const Typeform = ({
    id,
    color,
    icon = "document",
    label,
    headline,
    typeform,
    footertext,
    buttons,
    ...rest
}: TypeformProps): JSX.Element => {
    const el = useRef<HTMLDivElement>(null)

    const loadTypeform = (): void => {
        ;(window as CustomWindow & typeof globalThis).typeformEmbed.makeWidget(el.current, typeform)
    }

    const loadScript = (): void => {
        const src = "https://embed.typeform.com/embed.js"
        const typeformScript = document.querySelector("script[src*='" + src + "']")
        if (typeformScript) {
            loadTypeform()
        } else {
            const script = document.createElement("script")
            script.async = true
            script.src = src
            script.onload = loadTypeform
            const body = document.getElementsByTagName("body")[0]
            body.appendChild(script)
        }
    }
    useEffect(() => {
        if (!typeform) return
        loadScript()
    }, [])

    return (
        <Section
            id={id || undefined}
            className="typeform-section"
            shape="shape4"
            backgroundColor={color}
            icon={getIconPath(icon)}
            label={label}
            headline={headline}
            {...rest}
        >
            <FixedWidthContent>
                {typeform && <div ref={el} className="wrapper" id={id ? `${id}-typeform` : undefined} />}
            </FixedWidthContent>
            <BlockFooter footertext={footertext} buttons={buttons} position={headline} />
        </Section>
    )
}

export { Typeform }
